const FilterField = [
  {
    name: "id",
    label: "Company",
    select: true,
  },
  {
    name: "siteId",
    label: "Site",
    select: true,
  },
  {
    name: "pid",
    label: "Plan",
    select: true,
  },
  {
    name: "search",
    label: "Search",
    input: "text",
  },
  {
    name: "status",
    label: "Active",
    Switch: true,
  },
];
const Fields = [
  { label: "Plan", name: "planId" },
  { label: "Member Name", name: "memberName" },
  {
    label: "Start Date",
    name: "startDate",
  },
  {
    label: "Expire Date",
    name: "expireDate",
  },
  {
    label: "Balance",
    name: "balance",
  },
  { label: "Company", name: "Company" },
  { label: "Related Company", name: "relatedCompany" },
  { label: "Tag ID", name: "tagId" },
  { label: "Times per Day", name: "timesPerDay", validationType: "number" },
];

const CompanyFormFields = [
  { label: "Sites", name: "siteIds", multiSelect: true },
  {
    label: "Related Company",
    name: "relatedCompany",
    type: "text",
    validationType: "string",
    input: true,
  },

  {
    label: "Member Name",
    name: "memberName",
    type: "text",
    required: true,
    validationType: "string",
    input: true,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    label: "Mobile",
    name: "mobile",
    type: "text",
    required: true,
    validationType: "string",
    input: true,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  { label: "Start Date", name: "startDate", date: true },
  { label: "Expire Date", name: "expireDate", date: true },

  {
    label: "Payment Type",
    name: "paymentTypeId",
    select: true,
    required: true,
  },
  {
    label: "Amount",
    name: "amount",
    type: "number",
    required: true,
    input: true,
    validationType: "number",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
];

const SiteFormFields = [
  { label: "Site", name: "siteIds", select: true },
  {
    label: "Related Company",
    name: "relatedCompany",
    type: "text",
    validationType: "string",
    input: true,
  },
  {
    label: "Member Name",
    name: "memberName",
    type: "text",
    required: true,
    validationType: "string",
    input: true,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    label: "Mobile",
    name: "mobile",
    type: "text",
    required: true,
    validationType: "string",
    input: true,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  { label: "Start Date", name: "startDate", date: true },
  { label: "Expire Date", name: "expireDate", date: true },
  {
    label: "Payment Type",
    name: "paymentTypeId",
    select: true,
    required: true,
  },
  {
    label: "Amount",
    name: "amount",
    type: "number",
    required: true,
    input: true,
    validationType: "number",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
];

const RechargedFormFields = [
  {
    label: "Related Company",
    name: "relatedCompany",
    type: "text",
    validationType: "string",
    input: true,
  },
  {
    label: "Member Name",
    name: "memberName",
    type: "text",
    required: true,
    validationType: "string",
    input: true,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    label: "Mobile",
    name: "mobile",
    type: "text",
    required: true,
    validationType: "string",
    input: true,
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },

  {
    label: "Payment Type",
    name: "paymentTypeId",
    select: true,
    required: true,
  },
  {
    label: "Amount",
    name: "amount",
    type: "number",
    required: true,
    input: true,
    validationType: "number",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
];
const CarFields = [
  {
    label: "Member Name",
    name: "memberId",
    validationType: "number",
  },
  {
    label: "Plate",
    name: "plate",
    type: "text",
    required: true,
    validationType: "string",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    label: "Maker",
    name: "carMakerId",
    select: true,
    required: true,
  },
  {
    label: "Color",
    name: "carColorId",
    select: true,
    required: true,
  },
  {
    label: "Category",
    name: "categoryId",
    select: true,
    required: true,
  },
  {
    name: "isActive",
    label: "Status",
    switch: true,
    validationType: "boolean",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
];

const SiteServiceForm = [
  { label: "Site", name: "siteIds", select: true },
  { label: "Services", name: "serviceIds", multiSelect: true },
];

const ChargeFields = [
  {
    label: "Payment Type",
    name: "paymentTypeId",
    select: true,
    required: true,
  },

  {
    label: "Amount",
    name: "amount",
    type: "number",
    validationType: "number",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  { label: "Expire Date", name: "expireDate", date: true },
];

export {
  FilterField,
  Fields,
  CompanyFormFields,
  SiteFormFields,
  RechargedFormFields,
  CarFields,
  SiteServiceForm,
  ChargeFields,
};
